var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigurewrestling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 25.5967 21.0352",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 21.0352,
    opacity: 0,
    width: 25.5967,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3491 5.12109C20.7671 5.12109 21.9155 3.98438 21.9155 2.56641C21.9155 1.14844 20.7671 0 19.3491 0C17.9312 0 16.7944 1.14844 16.7944 2.56641C16.7944 3.98438 17.9312 5.12109 19.3491 5.12109ZM11.228 20.8828C11.9312 20.8828 12.4702 20.3086 12.4702 19.6289L12.4702 14.168C12.4702 13.6523 12.2359 13.2891 11.9312 12.9844L8.31007 9.35156L12.6929 8.23828C12.9155 8.17969 13.103 8.34375 13.103 8.56641L13.103 10.8984C13.103 11.2266 13.2319 11.543 13.4663 11.7773L17.1929 15.5273C17.6851 16.0078 18.4819 16.0078 18.9741 15.5273C19.4546 15.0469 19.4663 14.2383 18.9741 13.7578L15.5874 10.3945L15.5874 8.02734L17.4624 10.1602C17.7085 10.4297 18.0484 10.5938 18.3999 10.5938L24.0132 10.5938C24.7046 10.5938 25.2437 10.043 25.2437 9.33984C25.2437 8.64844 24.7046 8.10938 24.0132 8.10938L18.9741 8.10938L15.9859 4.66406C15.0601 3.59766 13.6304 3.17578 12.2593 3.51562L5.87257 5.12109C3.36476 5.75391 2.93117 8.85938 4.92335 10.4766L9.98585 14.6016L9.98585 19.6289C9.98585 20.3086 10.5366 20.8828 11.228 20.8828ZM0.364759 20.5195C0.845228 21 1.65382 21 2.14601 20.5195L6.50538 16.1602C6.72804 15.9258 6.79835 15.7148 6.86867 15.3398L7.14992 13.7578L4.37257 11.4961L4.37257 14.7539L0.364759 18.75C-0.127428 19.2305-0.115709 20.0391 0.364759 20.5195Z",
    fill: "currentColor",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigurewrestling);
export default __webpack_public_path__ + "static/media/figure.wrestling.7ef9bd05989111d862067464290845ca.svg";
export { ForwardRef as ReactComponent };